module.exports = __webpack_public_path__ + "img/apple.9b6ca60d.png";